// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yQ2x","colMin":"styles_colMin__1XyAC"};